import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Folder extends BaseModel {
  static modelName = 'Folder'
}

const servicePath = 'folders'
const servicePlugin = makeServicePlugin({
  Model: Folder,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
